import { Injectable } from '@angular/core';
import { Api } from './api.service';
import { BaseService } from './base.service';

@Injectable()
export class VehicleService extends BaseService {

  controllerName = 'api/vehicle';

  constructor(protected api: Api) {
    // put controller url for BaseService
    super(api, 'api/vehicle');
  }

  sample() {
    this.get(`${this.controllerName}/sample`);
  }


  checkAssignedToRoute(id: number): any {
    return this.api.get(`${this.controllerName}/check-assigned-to-route/${id}`);
  }

  getDropdown(name: string) {
    return this.api.get(`${this.controllerName}/search?name=${name}`);
  }

  getVehicleByDate(startDate: moment.Moment, endDate: moment.Moment) {
    const params: any = {
      startDate: startDate.format('L'), // MM/dd/yyyy
      endDate: endDate.format('L'), // MM/dd/yyyy
    };

    return this.api.get(`${this.controllerName}/get-list-by-date`, params);
  }

  getHistory(vehicleId: number, pageSize: number, pageIndex: number) {
    return this.api.get(`${this.controllerName}/get-vehicle-history/${vehicleId}?pageSize=${pageSize}&pageIndex=${pageIndex}`);
  }
}
